module.exports = __webpack_public_path__ + "static/faq@2x-dbd9d2db82e2c8067550b25f1f861bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/faq@2x.png
// module id = 2672
// module chunks = 168707334958949